/**
 * 设备状态转换工具
 */

/**
 * 设备状态码转换为中文描述
 * @param {string} state - 设备状态码
 * @returns {string} 中文状态描述
 */
export function getDeviceStatus(state) {
  const statusMap = {
    N: "初始",
    E: "正常",
    W: "异常",
    D: "停用",
    R: "删除",
  };

  return statusMap[state] || "未知";
}

/**
 * 在线状态码转换为中文描述
 * @param {number} online - 在线状态码
 * @returns {string} 中文状态描述
 */
export function getOnlineStatus(online) {
  const onlineMap = {
    0: "离线",
    1: "在线",
    3: "已拿卡",
    4: "拿卡失败",
    5: "正在拨号",
    6: "下线",
    11: "在线",
  };

  return onlineMap[online] || "--";
}

/**
 * 信号强度转换为中文描述
 * @param {number} sigint - 信号强度值
 * @returns {string} 信号强度描述
 */
export function getSignalStrength(sigint) {
  if (sigint === undefined || sigint === null) {
    return "--";
  }

  const checkSigint = -Math.abs(sigint);

  if (checkSigint > -80) {
    return "强";
  } else if (checkSigint > -97) {
    return "较强";
  } else if (checkSigint > -105) {
    return "较强";
  } else if (checkSigint > -110) {
    return "较弱";
  } else {
    return "弱";
  }
}

/**
 * 电池状态处理
 * @param {number} battery - 电池电量百分比
 * @param {string} deviceName - 设备名称
 * @returns {string} 电池状态描述
 */
export function getBatteryStatus(battery, deviceName) {
  // 特殊设备处理
  if (deviceName === "AX502H" || deviceName === "L70CB") {
    return "充电中";
  }

  if (battery === undefined || battery === null) {
    return "--";
  }

  return `${battery}%`;
}

/**
 * 连接设备数处理
 * @param {number} wificonnt - 连接设备数
 * @returns {string} 连接设备数描述
 */
export function getConnectedDevices(wificonnt) {
  if (wificonnt === undefined || wificonnt === null) {
    return "--";
  }

  return String(wificonnt);
}

/**
 * 套餐状态计算
 * @param {string} packageInvalidDate - 套餐到期日期
 * @returns {object} 套餐状态对象 {text, color}
 */
export function getPackageStatus(packageStatus) {
  if (packageStatus === "使用中") {
    return { text: "使用中", color: "#52C41A" };
  } else if (packageStatus === "待生效") {
    return { text: "待生效", color: "#FFB74C" };
  } else if (packageStatus === "已到期") {
    return { text: "已到期", color: "#FF3831" };
  } else if (packageStatus === "已失效") {
    return { text: "已失效", color: "#999999" };
  } else {
    return { text: packageStatus, color: "#999999" };
  }
}

/**
 * 网络频段转换
 * @param {number} hotspotBand - 热点频段值
 * @returns {string} 频段描述
 */
export function getNetworkBand(hotspotBand) {
  const bandMap = {
    0: "2.4G",
    1: "5G",
  };

  return bandMap[hotspotBand] || "2.4G";
}

/**
 * 日期格式化
 * @param {string} dateString - 日期字符串
 * @param {string} separator - 分隔符，默认为 '.'
 * @returns {string} 格式化后的日期
 */
export function formatDate(dateString, separator = ".") {
  if (!dateString) {
    return "---";
  }

  return dateString.replace(/-/g, separator);
}

/**
 * 获取设备状态信息对象
 * @param {object} deviceInfo - 设备信息对象
 * @returns {object} 处理后的设备状态信息
 */
export function getDeviceStatusInfo(deviceInfo) {
  return {
    deviceStatus: getDeviceStatus(deviceInfo.state),
    onlineStatus: getOnlineStatus(deviceInfo.online),
    signalStrength: getSignalStrength(deviceInfo.sigint),
    batteryStatus: getBatteryStatus(deviceInfo.battery, deviceInfo.modelName),
    connectedDevices: getConnectedDevices(deviceInfo.wificonnt),
  };
}

/**
 * 获取套餐信息对象
 * @param {object} packageInfo - 套餐信息对象
 * @returns {object} 处理后的套餐信息
 */
export function getPackageInfo(packageInfo) {
  return {
    packageId:packageInfo.packageId,
    topLeft: "套餐名称",
    topRight: packageInfo.packageName,
    centerLeft: "套餐描述",
    centerRight: packageInfo.packageDesc,
    footLeft: "套餐到期日",
    footRight: formatDate(packageInfo.packageInvalidDate),
    status: getPackageStatus(packageInfo.packageStatus),
    isUpgradeFlag:packageInfo.isUpgradeFlag,//是否能套餐升级，0否，1是
  };
}
